import React, { useState } from 'react';
import NotificationContext from '../context/notification.Context';

const NotificationProvider = ({ children }) => {

    /**
     * Theme details state / controls
     */
    const showMessage = ({
        newMessage
    }) => {
        setMessage(prevState => {
            const newMessageState = {
                ...prevState, message: newMessage, visible: true
            };
            return newMessageState;
        });
    };

    const hideMessage = () => {
        setMessage(prevState => {
            const newMessageState = {
                ...prevState, visible: false
            };
            return newMessageState;
        });
    };

    const setServerUnreachable = (isUnreachable) => {
        setMessage(prevState => {
            const newMessageState = {
                ...prevState, serverUnreachable: isUnreachable
            };
            return newMessageState;
        });
    };

    const initialMessage = {
        message: '',
        visible: false,
        serverUnreachable: false,
        showMessage,
        hideMessage,
        setServerUnreachable
    };

    const [message, setMessage] = useState(initialMessage);

    return (
        <NotificationContext.Provider value={message}>
            {children}
        </NotificationContext.Provider>
    );
};

export default NotificationProvider;


// WEBPACK FOOTER //
// ./src/components/NotificationProvider.js